import { useEffect, useState } from 'react';

export function useMediaQuery(query: string, defaultValue = false) {
  const getMatches = () => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return defaultValue;
    }

    return window.matchMedia(query).matches;
  };

  const [matches, setMatches] = useState<boolean>(getMatches);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return undefined;
    }

    const mediaQuery = window.matchMedia(query);
    const handleChange = (event: MediaQueryListEvent | MediaQueryList) => {
      setMatches(event.matches);
    };

    handleChange(mediaQuery);

    const listener = (event: MediaQueryListEvent) => handleChange(event);
    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', listener);
      return () => mediaQuery.removeEventListener('change', listener);
    }

    mediaQuery.addListener(listener);
    return () => mediaQuery.removeListener(listener);
  }, [query]);

  return matches;
}

export function useIsNarrowScreen(maxWidth = 640) {
  return useMediaQuery(`(max-width: ${maxWidth}px)`);
}

export function useIsTabletOrSmaller(maxWidth = 1024) {
  return useMediaQuery(`(max-width: ${maxWidth}px)`);
}
